<template lang="html">
    <header class="app-header">
        <div class="header-desktop-left">
            <div class="header-branding">
                <a data-v-4358f9fa="" href="/" class="active">
                    <div v-if="clientLogo">
                        <img class='nav-logo' :src="clientLogo"/>
                    </div>
                    <div v-else>
                        <logo></logo>
                    </div>
                </a>
            </div>
            <nav class="primary-nav">
                <router-link v-for="navItem in primaryNav" v-show="navItem.show" v-bind:key="navItem.id" :to="navItem.route" :class="{'active' : navItem.active}" >
                    <h3>{{ navItem.name }}</h3>
                </router-link>
            </nav>
        </div>
        <div class="header-desktop-right">
            <nav class="account-nav">
                <notifications-dropdown v-if="$isAllowed('viewNotifications')"></notifications-dropdown>
                <user-dropdown></user-dropdown>
            </nav>
        </div>
    </header>
</template>

<script>
    import logo from '../../assets/images/logo-acquire';
    import NavigationPerimeters from '../../configs/Perimeters/navigation';
    import NotificationsDropdown from './notifications-dropdown';
    import UserDropdown from './user-dropdown';

    export default {
        perimeters:[NavigationPerimeters],
        components: {
            logo,
            UserDropdown,
            NotificationsDropdown,
        },
        data () {
            return {
                primaryNav: [
                    {
                        name: 'Client Manager',
                        route: '/clients',
                        show: NavigationPerimeters.isAllowed('viewClients')
                    },
                    {
                        name: 'Offices',
                        route: '/offices',
                        show: NavigationPerimeters.isAllowed('viewAgencies')
                    },
                    {
                        name: 'Users',
                        route: '/users',
                        show: NavigationPerimeters.isAllowed('viewUsers')
                    },
                    {
                        name: 'Packages',
                        route: '/packages',
                        show: NavigationPerimeters.isAllowed('viewPackages')
                    },
                    {
                        name: 'Orders',
                        route: '/orders',
                        show: NavigationPerimeters.isAllowed('viewAllOrders')
                    },
                    {
                        name: 'Reports',
                        route: '/reports',
                        show: NavigationPerimeters.isAllowed('viewAllReports')
                    },
	                {
		                name: 'Global Report',
		                route: '/global-report',
		                show: NavigationPerimeters.isAllowed('viewAllOrders')
	                },
	                {
		                name: 'Audience',
		                route: '/audience',
		                show: NavigationPerimeters.isAllowed('accessAudienceFeatures') && !NavigationPerimeters.isAgencyUser() && !NavigationPerimeters.isAdmin() && !NavigationPerimeters.isSuperAdmin()
	                },
                    
	                {
		                name: 'Audience',
		                route: '/admin/audience',
		                show: NavigationPerimeters.isAdmin() || NavigationPerimeters.isSuperAdmin()
	                },
	                {
		                name: 'Admin Tools',
		                route: '/admin-tools',
		                show: NavigationPerimeters.isAllowed('useAdminTool') && (NavigationPerimeters.isAdmin() || NavigationPerimeters.isSuperAdmin())
	                },
                ],
                clientLogo: null,
                subdomain: null
            }
        },
        methods: {
        },
        mounted() {             
            const favicon = document.getElementById("favicon");
            const faviconApple = document.getElementById("favicon-apple");
            let logoUrl = this.$store.state.logo;
            let faviconUrl = this.$store.state.favicon;
            this.clientLogo = logoUrl ? logoUrl : null;
            if (faviconUrl) {
                favicon.href = faviconUrl;
                faviconApple.href = faviconUrl;
            }  
        }

    }
</script>

<style lang="scss" scoped>
    @import './src/assets/sass/vue';
    
</style>
